import { render, staticRenderFns } from "./v-cenario.vue?vue&type=template&id=2072cb9c&"
import script from "./v-cenario.vue?vue&type=script&lang=js&"
export * from "./v-cenario.vue?vue&type=script&lang=js&"
import style0 from "./v-cenario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports